import { useEffect, useState } from 'react';

export enum Keys {
  ENTER = 'Enter',
  SPACE = 'Space',
  ESCAPE = 'Escape'
}

export function useKeyPress(targetKey: string, options: { onKeyPressed?: (event: KeyboardEvent) => void } = {}) {
  // State for keeping track of whether key is pressed
  const [keyPressed, setKeyPressed] = useState(false);

  // If pressed key is our target key then set to true
  function downHandler(event: KeyboardEvent) {
    if (event.code === targetKey) {
      setKeyPressed(true);
      options.onKeyPressed?.(event);
    }
  }

  // If released key is our target key then set to false
  const upHandler = (event: KeyboardEvent) => {
    if (event.code === targetKey) {
      setKeyPressed(false);
    }
  };

  // Add event listeners
  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return keyPressed;
}
